import React from "react";

import {
  FaCode,
} from "react-icons/fa";

import logo from "../images/LOGO FD FINAL.png";

import "../css/footer.css";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="footer-divider" />

        <div className="footer-content">
          <div className="footer-left">
            <img
              src={logo}
              alt="FD"
              className="footer-logo-img"
            />

            <div className="footer-brand">
              <strong>
                TRANSPORTE DANLU
              </strong>

              <span>
                Sistema de Gestión
              </span>
            </div>
          </div>

          <div className="footer-right">
            <span className="footer-version">
              Versión 2.0
            </span>

            <span className="footer-separator">
              |
            </span>

            <span className="footer-author">
              <FaCode className="mr-1" />
              por FD
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;